import { render, staticRenderFns } from "./InsuranceBlock.vue?vue&type=template&id=ed4cd0d4&scoped=true"
import script from "./InsuranceBlock.vue?vue&type=script&lang=js"
export * from "./InsuranceBlock.vue?vue&type=script&lang=js"
import style0 from "./InsuranceBlock.vue?vue&type=style&index=0&id=ed4cd0d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4cd0d4",
  null
  
)

export default component.exports